import styled from 'styled-components'
import * as BannerImgXL from '../../../assets/cover-landing-moving-1920.jpg'
import * as BannerImgL from '../../../assets/cover-landing-moving-1440.jpg'
import * as BannerImgXS from '../../../assets/cover-landing-moving-320.jpg'

export const StyledBackground = styled.div`
  background-color: #f5f7fa;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media screen and (max-width: 780px) {
    background-image: url(${BannerImgXS});
    padding: 16px;
  }

  @media screen and (min-width: 781px) and (max-width: 1919px) {
    background-image: url(${BannerImgL});
  }

  @media screen and (min-width: 1920px) {
    background-image: url(${BannerImgXL});
  }
`

export const StyledFormContainer = styled.div`
  display: flex;
  margin: 0 auto;
  font-size: 16px;
  flex-wrap: wrap;
  justify-content: space-between;
  text-align: left;
`

export const StyledFormLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  @media screen and (min-width: 781px) {
    max-width: 45%;
    min-width: 365px;
  }

  @media screen and (max-width: 780px) {
    width: 100%;
    align-items: center;
  }
`

export const StyledTitle = styled.h1`
  display: flex;
  color: #262626;
  font-size: 32px;

  padding-top: 24px;

  @media screen and (max-width: 768px) {
    text-align: center;
    padding-top: 0px;
  }

  @media screen and (max-width: 480px) {
    font-size: 28px;
    margin: 12px;
  }
`

export const StyledRemise = styled.h3`
  background-color: #ff550b;
  color: #ffffff;
  font-size: 30px;
  padding: 6px;
  text-align: center;
  margin: 5px 0;
  width: fit-content;

  @media screen and (max-width: 480px) {
    font-size: 24px;
  }
`

export const StyledInfoContainer = styled.div`
  background-color: #f5f7fa;

  ul {
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
    max-width: 1280px;
    padding: 0;
  }

  li {
    list-style: none;
    display: inline;
  }

  @media screen and (max-width: 550px) {
    ul {
      flex-direction: column;
      padding: 0.3rem 1rem;
    }
  }
`

export const StyledInfoItem = styled.li`
  color: #262626;
  font-size: 20px;
  font-weight: normal;
  text-align: center;
  margin: 2.5rem auto;
  max-width: 250px;

  b {
    font-weight: 800;
  }

  span {
    display: block;
    font-size: 40px;
    font-weight: bolder;
  }
`
export const StyledFormSection = styled.div`
  @media screen and (min-width: 781px) {
    width: 33%;
    min-width: 380px;
  }

  @media screen and (max-width: 780px) {
    width: 100%;
  }
`
